import React, { Component } from 'react';
import { Container, Row, Col } from '../';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import logo from '../header/logo';

export const Logo = styled.a`
  margin: 5px 0 0 0;
  div {
    width: 90px;
    height: 33px;
    background: url(${logo}) no-repeat;
    background-size: contain;
    text-indent: -99999px;
    display: block;
  }
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    display: inline-block;
    margin: 1.875rem 0 1.5625rem;
    div {
      width: 120px;
      height: 44px;
      background: url(${logo}) no-repeat;
      display: inline-block;
      vertical-align: middle;
      margin-top: -0.625rem;
    }
  }
`;

export const Tagline = styled.span`
  color: #aaa;
  font-weight: 400;
  font-size: 11px;
  line-height: 28px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    font-size: 0.8125rem;
    margin-left: 1.25rem;
    padding-left: 1.25rem;
    border-left: 1px solid #ddd;
    color: #aaa;
    line-height: 19px;
    display: inline-block;
    vertical-align: middle;
  }
`;

export const HeaderLink = styled.div`
  margin-top: 1.75rem;
  text-align: right;
  font-size: 1rem;
  vertical-align: middle;
  a {
    color: #777;
    text-decoration: none;
    background-color: transparent;
  }
  a:focus,
  a:hover {
    text-decoration: underline;
  }
  a:focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }
  a:active,
  a:hover {
    outline-width: 0;
  }
  .hui-header__advertise-btn {
    padding: 0.375rem 0.75rem 0.5rem;
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid #888;
    color: #888;
    font-weight: 400;
    display: inline-block;
    margin-left: 20px;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
    box-shadow: none !important;
    background-color: transparent !important;
  }
  .hui-header__advertise-btn:active,
  .hui-header__advertise-btn:focus,
  .hui-header__advertise-btn:hover {
    color: #888;
    opacity: 0.8;
    text-decoration: none;
  }
  .hui-header__advertise-btn,
  .hui-header__advertise-btn:hover {
    text-decoration: none !important;
  }
  .hui-header__advertise-btn:focus {
    text-decoration: none !important;
    outline: none !important;
    box-shadow: none !important;
  }
`;

export const Burger = styled.div`
  padding: 25px 0 0 0;
  font-size: 18px;
  color: #888;
  display: inline-block;
  cursor: pointer;
  &:before {
    font-family: hui-icons;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: '\\E808';
  }
`;

export const MobileHeaderNav = styled.div`
  ul {
    margin-top: 0;
    margin-bottom: 1rem;
  }
  a {
    color: #777;
    text-decoration: none;
    background-color: transparent;
  }
  a:focus,
  a:hover {
    text-decoration: underline;
  }
  a:focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }
  a:active,
  a:hover {
    outline-width: 0;
  }
  .hui-header__mobile-nav {
    list-style: none;
    padding-left: 0;
    margin: 0;
  }
  .hui-header__mobile-nav-item {
    font-size: 14px;
    text-decoration: none;
    padding: 10px 0;
    display: block;
    border-top: 1px solid #ddd;
  }
  .hui-header__mobile-nav-item a {
    color: #333;
  }
`;

export class HeaderSimple extends Component {
  static propTypes = {
    siteSource: PropTypes.string
  };
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }
  toggleMenu() {
    this.setState({ show: !this.state.show });
  }
  render() {
    const { siteSource } = this.props;
    return (
      <div>
        <Container>
          <Row>
            <Col xs={9} md={8}>
              <Logo
                href="/"
                rel="noopener noreferrer"
                data-ga-category={siteSource}
                data-ga-action={`${siteSource} - Clicked Home`}
                data-ga-label={`${siteSource} - Clicked Home`}
              >
                <div />
              </Logo>
              <Tagline>Australia&apos;s #1 site to hire tradespeople</Tagline>
            </Col>
            <Col xs={0} md={4} style={{ textAlign: 'right' }}>
              <HeaderLink>
                <a
                  href="/login"
                  title="Sign in"
                  data-ga-category={siteSource}
                  data-ga-action={`${siteSource} - Clicked Sign In`}
                  data-ga-label={`${siteSource} - Clicked Sign In`}
                >
                  Sign in
                </a>
                <a
                  href="/advertise"
                  title="List your business"
                  className="hui-header__advertise-btn"
                  data-ga-category={siteSource}
                  data-ga-action={`${siteSource} - Clicked List Your Business`}
                  data-ga-label={`${siteSource} - Clicked List Your Business`}
                >
                  List your business
                </a>
              </HeaderLink>
            </Col>
            <Col xs={3} md={0} style={{ textAlign: 'right' }}>
              <Burger
                onClick={this.toggleMenu}
                data-ga-category={siteSource}
                data-ga-action={`${siteSource} - Clicked Hamburger Menu Mobile`}
                data-ga-label={`${siteSource} - Clicked Hamburger Menu Mobile`}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={0} style={{ textAlign: 'right' }}>
              {this.state.show && (
                <MobileHeaderNav>
                  <ul className="hui-header__mobile-nav">
                    <li className="hui-header__mobile-nav-item">
                      <a
                        href="/login"
                        title="Sign in"
                        data-ga-category={siteSource}
                        data-ga-action={`${siteSource} - Clicked Sign In Mobile`}
                        data-ga-label={`${siteSource} - Clicked Sign In Mobile`}
                      >
                        Sign in
                      </a>
                    </li>
                    <li className="hui-header__mobile-nav-item">
                      <a
                        href="/advertise"
                        title="List Your Business"
                        data-ga-category={siteSource}
                        data-ga-action={`${siteSource} - Clicked List Your Business Mobile`}
                        data-ga-label={`${siteSource} - Clicked List Your Business Mobile`}
                      >
                        List Your Business
                      </a>
                    </li>
                  </ul>
                </MobileHeaderNav>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
